@if (call(); as c) {
  <aside class="call-popover animate-slide-right" role="alert" aria-label="Appel entrant">
    <div class="call-popover-inner">
      <!-- Animated neon border top -->
      <div class="call-neon-bar"></div>

      <div class="call-content">
        <div class="call-left">
          
          <div class="call-details">
            <span class="call-label">Appel entrant</span>
            @if (c.clientNom) {
              <strong class="call-name">{{ c.clientNom }}</strong>
              <small class="call-phone">{{ c.telephone }}</small>
            } @else {
              <strong class="call-name">Client inconnu</strong>
              <small class="call-phone">{{ c.telephone }}</small>
            }
          </div>
        </div>

        <div class="call-actions">
          @if (c.clientId && c.clientNom) {
            @if (peutCreerTicket()) {
              <button class="call-btn call-btn-primary" (click)="openTicket(c)">
                <span>Ouvrir ticket</span>
              </button>
            }
          } @else {
            @if (peutCreerClient()) {
              <button class="call-btn call-btn-secondary" (click)="createClient(c)">
                <span>Nouveau client</span>
              </button>
            }
            @if (peutCreerTicket()) {
              <button class="call-btn call-btn-outline" (click)="openTicket(c)">
                <span>Attacher</span>
              </button>
            }
          }
          <button class="call-btn call-btn-dismiss" (click)="dismiss()" aria-label="Ignorer l'appel">
          </button>
        </div>
      </div>
    </div>
  </aside>
}
